import { Routes, Route } from 'react-router-dom';
import Layout from './components/Layout';

// Hovedsider
import Home from './pages/Home';
import Om from './pages/Om';
import Ordbog from './pages/Ordbog';
import NotFound from './pages/NotFound';

// Klynge A: Radiatoren varmer ikke
import RadiatorVarmerIkke from './pages/clusterA/RadiatorVarmerIkke';
import RadiatorKoldIBunden from './pages/clusterA/RadiatorKoldIBunden';
import RadiatorVarmerIkkeEfterUdluftning from './pages/clusterA/RadiatorVarmerIkkeEfterUdluftning';
import FjernvarmeRadiatorVirkerIkke from './pages/clusterA/FjernvarmeRadiatorVirkerIkke';
import ElRadiatorVarmerIkke from './pages/clusterA/ElRadiatorVarmerIkke';
import GammelRadiatorVarmerIkke from './pages/clusterA/GammelRadiatorVarmerIkke';
import RadiatorOgVarmepumpe from './pages/clusterA/RadiatorOgVarmepumpe';

// Klynge B: Lyde
import RadiatorKlikker from './pages/clusterB/RadiatorKlikker';
import RadiatorLarmer from './pages/clusterB/RadiatorLarmer';
import RadiatorLyderSomVand from './pages/clusterB/RadiatorLyderSomVand';
import RadiatorBankerFjernvarme from './pages/clusterB/RadiatorBankerFjernvarme';

// Klynge C: Udluftning, ventiler, termostat, tryk
import UdluftningAfRadiator from './pages/clusterC/UdluftningAfRadiator';
import RadiatorLuftskrueSidderFast from './pages/clusterC/RadiatorLuftskrueSidderFast';
import RadiatorTermostat from './pages/clusterC/RadiatorTermostat';
import RadiatorTermostatIndstilling from './pages/clusterC/RadiatorTermostatIndstilling';
import RadiatorVentilSidderFast from './pages/clusterC/RadiatorVentilSidderFast';
import RadiatorReturventil from './pages/clusterC/RadiatorReturventil';
import RadiatorLaekker from './pages/clusterC/RadiatorLaekker';
import RadiatorTryk from './pages/clusterC/RadiatorTryk';
import HvordanVirkerEnRadiator from './pages/clusterC/HvordanVirkerEnRadiator';
import SparPaaVarmen from './pages/clusterC/SparPaaVarmen';
import RadiatorUdskiftningPris from './pages/clusterC/RadiatorUdskiftningPris';
import Radiatornoegle from './pages/clusterC/Radiatornoegle';
import RadiatorVarmerSelvomDenErSlukket from './pages/clusterC/RadiatorVarmerSelvomDenErSlukket';

export default function App() {
  return (
    <Layout>
      <Routes>
        {/* Forside */}
        <Route path="/" element={<Home />} />

        {/* Klynge A */}
        <Route path="/radiator-varmer-ikke" element={<RadiatorVarmerIkke />} />
        <Route path="/radiator-kold-i-bunden" element={<RadiatorKoldIBunden />} />
        <Route path="/radiator-varmer-ikke-efter-udluftning" element={<RadiatorVarmerIkkeEfterUdluftning />} />
        <Route path="/fjernvarme-radiator-virker-ikke" element={<FjernvarmeRadiatorVirkerIkke />} />
        <Route path="/el-radiator-varmer-ikke" element={<ElRadiatorVarmerIkke />} />
        <Route path="/gammel-radiator-varmer-ikke" element={<GammelRadiatorVarmerIkke />} />
        <Route path="/radiator-og-varmepumpe" element={<RadiatorOgVarmepumpe />} />

        {/* Klynge B */}
        <Route path="/radiator-klikker" element={<RadiatorKlikker />} />
        <Route path="/radiator-larmer" element={<RadiatorLarmer />} />
        <Route path="/radiator-lyder-som-vand" element={<RadiatorLyderSomVand />} />
        <Route path="/radiator-banker-fjernvarme" element={<RadiatorBankerFjernvarme />} />

        {/* Klynge C */}
        <Route path="/udluftning-af-radiator" element={<UdluftningAfRadiator />} />
        <Route path="/radiator-luftskrue-sidder-fast" element={<RadiatorLuftskrueSidderFast />} />
        <Route path="/radiator-termostat" element={<RadiatorTermostat />} />
        <Route path="/radiator-termostat-indstilling" element={<RadiatorTermostatIndstilling />} />
        <Route path="/radiator-ventil-sidder-fast" element={<RadiatorVentilSidderFast />} />
        <Route path="/radiator-returventil" element={<RadiatorReturventil />} />
        <Route path="/radiator-laekker" element={<RadiatorLaekker />} />
        <Route path="/radiator-tryk" element={<RadiatorTryk />} />
        <Route path="/hvordan-virker-en-radiator" element={<HvordanVirkerEnRadiator />} />
        <Route path="/spar-paa-varmen" element={<SparPaaVarmen />} />
        <Route path="/radiator-udskiftning-pris" element={<RadiatorUdskiftningPris />} />
        <Route path="/radiatornoegle" element={<Radiatornoegle />} />
        <Route path="/radiator-varmer-selvom-den-er-slukket" element={<RadiatorVarmerSelvomDenErSlukket />} />

        {/* Om og Ordbog */}
        <Route path="/om" element={<Om />} />
        <Route path="/ordbog" element={<Ordbog />} />

        {/* 404 side */}
        <Route path="*" element={<NotFound />} />
      </Routes>
    </Layout>
  );
}
